import TitleComponent from "../components/common/TitleComponent";
import { BiWorld } from "react-icons/bi";
import { IoIosPhonePortrait } from "react-icons/io";
import { BsEnvelope } from "react-icons/bs";
import { LuClock4 } from "react-icons/lu";
import { useState } from "react";

import { ToastContainer, toast } from "react-toastify";
import { AppDispatch } from "../api/store";
import { useDispatch } from "react-redux";
import contactUs from "./../assets/images/bannerImage/contact.webp";
import {
  clearEmailError,
  clearEmailSuccess,
  fetchEmail,
} from "../api/slices/emailSlice";
import BreadcrumbsComponent from "../components/common/BreadcrumbsComponent";

const ContactUsContent = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const [isSubmitting, setIsSubmitting] = useState(false);

  const dispatch = useDispatch<AppDispatch>();
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    dispatch(clearEmailError());
    dispatch(clearEmailSuccess());

    try {
      setIsSubmitting(true);
      await dispatch(
        fetchEmail({
          name: formData.name,
          email: formData.email,
          mobile: formData.phone,
          desc: formData.message,
        })
      ).unwrap(); // unwrap() is important to properly catch errors

      // Success case
      setFormData({ name: "", email: "", phone: "", message: "" });
      toast.success("Your message has been sent successfully!", {
        position: "top-right",
        autoClose: 5000,
      });
    } catch (error) {
      // Error case
      console.error("Error sending message:", error);
      toast.error("Failed to send message. Please try again later.", {
        position: "top-right",
        autoClose: 5000,
      });
    } finally {
      setIsSubmitting(false);
    }
  };
  const BreadCrumbsPath = [
    {
      id: 1,
      pathName: "Contact",
      pathLink: "/contact-us",
    },
  ];

  return (
    <>
      <div className="mt-20 xl:mt-0 hidden md:block">
        <div className="flex mb-2 items-center justify-center">
          <img
            src={contactUs}
            alt="Ceylon Hospital Banner"
            width={1200}
            height={630}
            loading="eager"
            className="w-full  max-w-8xl"
            decoding="async"
            style={{
              height: "auto",
              objectFit: "cover",
            }}
          />
        </div>
      </div>
      <BreadcrumbsComponent breadCrumbsPath={BreadCrumbsPath} />
      <div className=" px-2 mb-3">
        <div className=" ">
          <TitleComponent Title={"We'd Love to Hear from You"} Subtitle={""} />

          <div className="flex flex-col lg:flex-row gap-2 lg:px-20 mt-6 ">
            <div className="w-full lg:w-1/2 ">
              <div className="flex flex-col gap-2 ">
                <div className="flex bg-gray-100 rounded-lg border p-3 h-1/3 gap-3 items-center">
                  <div className="flex items-center lg:h-20 ">
                    <BiWorld size={60} color="green" />
                  </div>
                  <div className="flex flex-col leading-tight ">
                    <p className=" Blinker-SemiBold  text-gray-700 lg:text-lg text-md">
                      Address:
                    </p>
                    <p className=" Blinker-Regular text-gray-700 lg:text-lg text-sm">
                      No:228/1, Asiri Mawatha, Kandy Road, Yakkala, Gampaha
                    </p>
                  </div>
                </div>
                <div className="flex bg-gray-100 rounded-lg border p-3 h-1/3 gap-3 items-center justify-center">
                  <div className="flex items-center lg:h-20">
                    <IoIosPhonePortrait size={60} color="green" />
                  </div>
                  <div className="flex lg:flex-row flex-row gap-5 lg:gap-20 w-full">
                    <div className="flex flex-col">
                      <p className="Blinker-SemiBold  text-gray-700 lg:text-lg text-md">
                        Phone:
                      </p>
                      <p className="Blinker-Regular text-gray-700 lg:text-lg text-sm">
                        +94 71 250 9898
                      </p>
                    </div>
                    <div className="flex lg:items-center lg:justify-center">
                      <a
                        href="https://wa.me/94705509898"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex shadow-md Blinker-Regular text-sm hover:opacity-85 py-2 px-5 bg-green-500 rounded-md text-white text-center justify-center"
                      >
                        WhatsApp
                      </a>
                    </div>
                  </div>
                </div>
                <div className="flex bg-gray-100 rounded-lg border p-3 h-1/3 gap-3 items-center">
                  <div className="flex items-center lg:h-20">
                    <BsEnvelope size={60} color="green" />
                  </div>
                  <div className="flex flex-col leading-tight">
                    <p className="Blinker-SemiBold   text-gray-700 lg:text-lg text-md">
                      Email:
                    </p>
                    <p className="Blinker-Regular text-gray-700 lg:text-lg text-sm">
                      <a
                        href="mailto:info@ceylonhospital.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="hover:underline"
                      >
                        info@ceylonhospital.com
                      </a>
                    </p>
                  </div>
                </div>
                <div className="flex bg-gray-100 rounded-lg border p-3 h-1/3 gap-3 items-center">
                  <div className="flex items-center lg:h-20">
                    <LuClock4 size={60} color="green" />
                  </div>
                  <div className="flex flex-col leading-tight">
                    <p className="Blinker-SemiBold  text-gray-700 lg:text-lg text-md">
                      Open 24/7
                    </p>
                    <p className="Blinker-Regular text-gray-700 lg:text-lg text-sm">
                      We're always here when you need us
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Form area */}
            <div className="w-full lg:w-1/2 Blinker-Regular">
              <div className="lg:p-7 p-4 bg-gray-100 rounded-lg  border">
                <form onSubmit={handleSubmit}>
                  <div className="mb-2 w-full flex flex-col gap-5">
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your name"
                      className="p-2.5 border rounded border-gray-400 w-full text-sm focus:outline-none focus:border-green-400 focus:shadow-sm hover:border-green-300 hover:shadow-sm"
                      required
                    />
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="Enter your email"
                      className="p-2.5 border rounded border-gray-400 w-full text-sm focus:outline-none focus:border-green-400 focus:shadow-sm hover:border-green-300 hover:shadow-sm"
                      required
                    />
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="Enter your mobile number"
                      className="p-2.5 border rounded border-gray-400 w-full text-sm focus:outline-none focus:border-green-400 focus:shadow-sm hover:border-green-300 hover:shadow-sm"
                      required
                    />
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="Write Your message"
                      className="p-2.5 border rounded border-gray-400 w-full h-32 text-sm focus:outline-none focus:border-green-400 focus:shadow-sm hover:border-green-300 hover:shadow-sm"
                      required
                    />

                    <div className="flex justify-end">
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className={`px-10 py-3 bg-green-500 text-white rounded-md hover:opacity-85 ${
                          isSubmitting ? "opacity-70 cursor-not-allowed" : ""
                        }`}
                      >
                        {isSubmitting ? "Sending..." : "Send Message"}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <ToastContainer position="top-right" autoClose={2000} />
        </div>{" "}
      </div>
    </>
  );
};

export default ContactUsContent;
